import moment from 'moment'

import actions from '../actions.js'

export default {
  data () {
    return {
      actions: actions,
    }
  },
  computed: {
    // ユーザーの企業コード
    companyCd () {
      return this.$store.state.auth.user.username.split('#')[0]
    },
    // アクションが利用可能な場合、true
    canAction () {
      return actionId => {
        const user = this.$store.state.header.user
        return user ? user.action_ids.includes(actionId) : false
      }
    },
    // 管理画面の場合、true
    isAdmin () {
      return this.$route.meta.isAdmin
    },
    // 設定画面の場合、true
    isSetting () {
      return this.$route.meta.isSetting
    },
    // ログインユーザーにデフォルトの管理者権限がある場合、true
    isAdminUser () {
      return this.$store.state.header.user.role_ids.includes('builtin:root')
    },
    /**
     * デモ環境（開発環境/ローカル環境含む）かどうか
     * @returns デモ環境の場合、true
     */
    isDemoEnv () {
      const environment = this.$store.state.environment
      return environment === 'demo'
    },
    /**
     * シノプスユーザかどうか
     * @returns シノプスユーザの場合、true
     */
    isSinopsUser () {
      return this.companyCd && this.companyCd === 'SINOPS'
    },
  },
  methods: {
    /**
     * サービス時間のチェック
     * @return サービス時間内の場合、true
     */
    async checkLoginTime () {
      const user = this.$store.state.header.user
      if (!user) {
        return true // 「/me」用
      }

      const startTime = moment(user.service_start_time, 'HH:mm')
      const endTime = moment(user.service_end_time, 'HH:mm')
      if (user.service_start_time > user.service_end_time) {
        // サービス終了時間が開始時間より早い場合、翌日判定
        endTime.add(1, 'days')
      }

      // const sendTime = new Date().getTime()
      // const superagent = require('superagent')
      // const res = await superagent.get("https://ntp-a1.nict.go.jp/cgi-bin/json")
      // const now = moment(parseInt(res.body.st * 1000 + (new Date().getTime() - sendTime) / 2, 10))
      const now = moment();

      const flg = now.isSameOrAfter(startTime) && now.isSameOrBefore(endTime)
      if (!flg) {
        this.$store.commit('error/setLoginTimeErrorModal', {
          show: true,
          loginServiceTime: {
            start_time: this.$store.state.header.user.service_start_time,
            end_time: this.$store.state.header.user.service_end_time,
          },
        })
        this.$store.commit('setLoading', false)
      }
      return flg
    },
    /**
     * ローディングオーバーレイを表示する
     */
    startLoading () {
      this.$store.commit('setLoading', true)
    },
    /**
     * ローディングオーバーレイを非表示にする
     */
    stopLoading () {
      this.$store.commit('setLoading', false)
    },
    /**
     * フォーカスする
     * @param {string} refName ref名
     */
    focus (refName) {
      window.setTimeout(() => {
        this.$refs[refName].focus()
      }, 200)
    },
    /**
     * メニューを隠す
     * @param {Object} event イベント
     */
    hideMainMenu (event = null) {
      if (event) {
        event.preventDefault()
      }
      document.getElementById('app_wrapper').classList.add('hide-sidebar')
      return false
    },
    /**
     * メニューの開閉
     * @param {Object} event イベント
     */
    toggleMainMenu (event) {
      event.preventDefault()
      document.getElementById('app_wrapper').classList.toggle('hide-sidebar')
      return false
    },
    /**
     * ヘッダーの店舗一覧を更新する
     */
    async setHeaderStoreList () {
      const result = await this.getData('common', `/company/${this.companyCd}/store`)
      this.$store.commit('header/setStoreList', result.list)
    },
    /**
     * 全体のフォントサイズを変更する
     * @param fontSize {String} フォントサイズ
     */
    changeGlobalFontSize (fontSize) {
      const html = document.getElementsByTagName('html')
      html[0].style.fontSize = fontSize

      const body = document.getElementsByTagName('body')
      body[0].classList.remove('f-small')
      body[0].classList.remove('f-middle')
      body[0].classList.remove('f-large')
      switch (fontSize) {
        case '16px':
          body[0].classList.add('f-small')
          break
        case '18px':
          body[0].classList.add('f-middle')
          break
        case '20px':
          body[0].classList.add('f-large')
          break
      }
    },
    /**
     * 天気画像を取得する
     * @param {int} index 天気の番号
     * @returns 天気の画像の名前
     */
    getWeatherImage (index) {
      switch (index) {
        case 1:
          return `/images/weather/sunny.png`
        case 2:
          return `/images/weather/cloudy.png`
        case 3:
          return `/images/weather/rain.png`
        case 4:
          return `/images/weather/snow.png`
        default:
          return ''
      }
    },
    /**
     * 店舗名取得
     * @param {string} storeCd 店舗コード
     * @returns 店舗名
     */
    getStoreName (storeCd) {
      const store = this.$store.state.header.storeList.find(store => store.store_cd === storeCd)
      return store ? store.store_name : ''
    },
    /**
     * パターン名取得
     * @param {string} patternCd パターンコード
     * @returns パターン名
     */
    getPatternName (patternCd) {
      return 'パターン' + Number(patternCd)
    }
  }
}
